// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AccountPayorRelationModel } from './accountPayorRelationModel.js';
import type { AccountRelationModel } from './accountRelationModel.js';
import type { AccountStatus } from './accountStatus.js';
import type { AccountType } from './accountType.js';
import type { DocumentRelationshipModel } from './documentRelationshipModel.js';
import type { VoicemailOptInModel } from './voicemailOptInModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountSaveModel {
    'accountType'?: AccountType;
    'accountStatus'?: AccountStatus;
    'partyId'?: number;
    'securePartyId'?: string;
    'assignedUser'?: number;
    'payors'?: Array<AccountPayorRelationModel>;
    'prescribers'?: Array<AccountRelationModel>;
    'sites'?: Array<AccountRelationModel>;
    'pharmacies'?: Array<AccountRelationModel>;
    'documents'?: Array<DocumentRelationshipModel>;
    'notes'?: Array<number>;
    'tasks'?: Array<number>;
    'voicemailOptInStatus'?: Array<VoicemailOptInModel>;
    'assignmentOfBenefitFlag'?: boolean;
    'isIneligibleForMailInClaims'?: boolean;
    'allowAutoReenroll'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountSaveModel>> = [
        {
            "name":     "accountType",
            "baseName": "accountType",
            "type":     "AccountType"
        },
        {
            "name":     "accountStatus",
            "baseName": "accountStatus",
            "type":     "AccountStatus"
        },
        {
            "name":     "partyId",
            "baseName": "partyId",
            "type":     "number"
        },
        {
            "name":     "securePartyId",
            "baseName": "securePartyId",
            "type":     "string"
        },
        {
            "name":     "assignedUser",
            "baseName": "assignedUser",
            "type":     "number"
        },
        {
            "name":     "payors",
            "baseName": "payors",
            "type":     "Array<AccountPayorRelationModel>"
        },
        {
            "name":     "prescribers",
            "baseName": "prescribers",
            "type":     "Array<AccountRelationModel>"
        },
        {
            "name":     "sites",
            "baseName": "sites",
            "type":     "Array<AccountRelationModel>"
        },
        {
            "name":     "pharmacies",
            "baseName": "pharmacies",
            "type":     "Array<AccountRelationModel>"
        },
        {
            "name":     "documents",
            "baseName": "documents",
            "type":     "Array<DocumentRelationshipModel>"
        },
        {
            "name":     "notes",
            "baseName": "notes",
            "type":     "Array<number>"
        },
        {
            "name":     "tasks",
            "baseName": "tasks",
            "type":     "Array<number>"
        },
        {
            "name":     "voicemailOptInStatus",
            "baseName": "voicemailOptInStatus",
            "type":     "Array<VoicemailOptInModel>"
        },
        {
            "name":     "assignmentOfBenefitFlag",
            "baseName": "assignmentOfBenefitFlag",
            "type":     "boolean"
        },
        {
            "name":     "isIneligibleForMailInClaims",
            "baseName": "isIneligibleForMailInClaims",
            "type":     "boolean"
        },
        {
            "name":     "allowAutoReenroll",
            "baseName": "allowAutoReenroll",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return AccountSaveModel.attributeTypeMap;
    }
}
